import type { PortalEstado } from '@contefy/shared';
import { Check } from 'lucide-react';
import { dataCurta } from '../lib/formatos';
import { Cartao, Titulo } from './ui';

export function LinhaDoTempo({ estado }: { estado: PortalEstado }) {
  return (
    <Cartao>
      <Titulo sub="Cada mudança de etapa chega no seu WhatsApp.">Acompanhamento</Titulo>
      <ol className="relative ml-3 border-l-2 border-slate-200">
        {estado.linha_do_tempo.map((e) => {
          const atual = e.status === 'atual';
          const feita = e.status === 'concluida';
          return (
            <li key={e.etapa} className="mb-5 ml-5 last:mb-0">
              <span
                className={`absolute -left-[13px] flex h-6 w-6 items-center justify-center rounded-full border-2 text-xs font-semibold ${
                  feita
                    ? 'border-emerald-500 bg-emerald-500 text-white'
                    : atual
                      ? 'border-marca-600 bg-white text-marca-700 ring-4 ring-marca-100'
                      : 'border-slate-300 bg-white text-slate-400'
                }`}
              >
                {feita ? <Check className="h-3.5 w-3.5" /> : e.numero}
              </span>
              <p
                className={`text-sm font-medium ${atual ? 'text-marca-900' : feita ? 'text-slate-700' : 'text-slate-400'}`}
              >
                {e.titulo}
                {atual && e.em && (
                  <span className="ml-2 text-xs font-normal text-slate-500">
                    desde {dataCurta(e.em)}
                  </span>
                )}
              </p>
              {atual && <p className="mt-0.5 text-sm text-slate-600">{e.descricao}</p>}
            </li>
          );
        })}
      </ol>
    </Cartao>
  );
}
